import { toWorld, type Viewport } from './viewport';
import { vec } from '$lib/core/geom';

export interface GridSpec {
  readonly step: number;
  readonly majorEvery: number;
  readonly min: { x: number; y: number };
  readonly max: { x: number; y: number };
}

const STEPS = [1, 2, 5];

/** Picks the smallest 1/2/5-decade step whose on-screen spacing is at least `minPx`. */
export function gridStep(baseSize: number, zoom: number, minPx = 8): number {
  const base = baseSize > 0 ? baseSize : 1;
  let decade = Math.pow(10, Math.floor(Math.log10(base)) - 2);
  for (let guard = 0; guard < 40; guard += 1) {
    for (const factor of STEPS) {
      const step = decade * factor;
      if (step >= base && step * zoom >= minPx) return step;
    }
    decade *= 10;
  }
  return base;
}

export function gridSpec(viewport: Viewport, baseSize: number): GridSpec {
  const step = gridStep(baseSize, viewport.zoom);
  const topLeft = toWorld(viewport, vec(0, 0));
  const bottomRight = toWorld(viewport, vec(viewport.width, viewport.height));
  return {
    step,
    majorEvery: 5,
    min: { x: Math.floor(topLeft.x / step) * step, y: Math.floor(bottomRight.y / step) * step },
    max: { x: Math.ceil(bottomRight.x / step) * step, y: Math.ceil(topLeft.y / step) * step },
  };
}
